export type Method = 'UNKNOWN' | 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export interface IServiceResponse {
  metadata?: any;
  report: Array<any>;
  Error: number;
  Msg: string;
  Code: string;
  ID?: string;
  Version: string;
  Next?: boolean;
  Limit?: number;
  Offset?: number;
}

export const emptyServiceResponse: IServiceResponse = {
  metadata: null,
  report: [],
  Error: 0,
  Msg: '',
  Code: '',
  ID: '',
  Version: '1',
  Next: false
};

export interface IRdfServiceResponseError {
  method: Method; //Метод который использовался для вызова сервиса
  errorCode: number; //Код ошибки
  rdfErrorCode: string; //Rdf код ошибки
  msg: string; //Текстовое сообщение ошибки
  rdfMsg: string;
  description: string;
  isHttpError: boolean; //Признак того что в errorCode лежит http код. Если false - то там лежит внутренний код RDF
  url: string; //URL по которому проходил запрос
  requestParams: object; //header параметры запроса
  requestBody: object; //body запроса
  response?: object;//Ответ сервиса при ошибке
}
export const emptyRdfServiceResponseError: IRdfServiceResponseError = {
  method: 'UNKNOWN',
  errorCode: 0,
  rdfErrorCode: '',
  msg: '',
  rdfMsg: '',
  description: '',
  isHttpError: false,
  url: '',
  requestParams: null,
  requestBody: null,
  response: null
};


export interface IAdminApplicationsResponse extends IServiceResponse {
  report: Array<{
    app_name: string;
    app_icon: string;
    host_url: string;
    app_url: string;
    profile: any;
    app_short_name: string;
    id_party_owner: number;
    app_id: number;
    app_description: string;
    app_code: string;
    app_platform_code: string;
  }>;
}
export interface IAdminResourcesResponse extends IServiceResponse {
  report: Array<{
    app_id: number;
    resource_id: number;
    resource_code: string;
    resource_name: string;
    resource_description: string;
    resource_type: string;
    order_no: number;
    profile: any;
  }>;

}

export interface IPlatformPartyResponse extends IServiceResponse {
  report: Array<{
    "ID": string;
    "Name": string;
    "TypeCode": string;
    "email": string;
    "TypeName": string;
    "StatusCode": string;
    "StatusName": string;
    "LegalID": string;
    "City": string;
    "Created Date": string; //dd.mm.yyyy
    "Last Usage Date": string; //dd.mm.yyyy
    "ParentRelationshipStatus": string;
    "ChildRelationshipStatus": string;
    "Applications Count": string;
    "profile";
    "Users count": string;
    "MainURL": string;
    "ProfileRlshp";
    "IdRlshp": null,
    "LegalAddress": string;
    "ProfileChldRlshp": string;
    "IdChldRlshp": string;
    "SentPrtyId": string;
    "SentLastRqSt": string;
    "SentRqCnt": string;
    "RcvdPrtyId": string;
    "RcvdLastRqSt": string;
    "RcvdRqCnt": string;
    "Kpp": string;
    "credit_limit": string;
    "min_value_order": string;
    "ParentRelationshipPartyId": string;
    "ChildRelationshipPartyId": string;
  }>;

}

